import React, { Fragment, useState, useEffect } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate, useLocation } from "react-router";
import FInfoCard from "../../components/FInfoCard/FInfoCard";
import { getcontactInfo, deleteContactInfoById } from "../../api/contactInfo";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import PhoneInput from "react-phone-input-2";
import { useFormik } from "formik";
import FInputt from "../../components/FInputt/FInputt";
import { useContactInfo } from "../../hooks/useContactInfo";
import * as Yup from "yup";
import FContainer from "../../components/FContainer/FContainer";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import Switch from "react-switch";

const CreateEmailScreen = ({ param }) => {
  const parameters = useLocation();
  const { sendOtpEmail, getEmails, emails } = useContactInfo();
  const route = useNavigate();

  const [principal, setPrincipal] = useState(false);

  const nextScreen = async (email) => {
    route("/EmailOTPScreen", {
      state: {
        typeOfContactId: "MAIL",
        contact: email,
        isPrincipal: principal,
      },
    });
  };

  const validate = Yup.object({
    email: Yup.string()
      .required("Ingresa tu correo electrónico.")
      .email("Escribe un correo electrónico válido."),
  });

  const { values, setFieldValue, handleSubmit, errors, dirty, isValid } =
    useFormik({
      initialValues: {
        email: "",
      },
      onSubmit: (values) => {
        const { email } = values;
        nextScreen(email);
      },
      validationSchema: validate,
    });

  useEffect(() => {
    getEmails();
  }, []);

  useEffect(() => {
    setPrincipal(emails.length > 0 ? false : true);
  }, [emails]);

  return (
    <>
      <div className="border-0 grid place-items-center">
        <div className="border-0 grid grid-cols-12 xss:w-[450px] place-items-center">
          <div className="border-0 col-span-5 p-5">
            <img
              src={require("../../components/assets/images/mail.png")}
              className="w-full xxs:w-[120px] h-auto flex-1"
            />
          </div>
          <div className="border-0 col-span-7 grid grid-rows-2 text-center sm:py-7 ">
            <div className="border-0 row-span-1 font-bold text-Secondary text-[5vw] smm:text-[20px]">
              Crea tu correo
            </div>
            <div className="border-0 row-span-1 font-regular text-[4vw] smm:text-[20px]">
              Crea tu correo electrónico
            </div>
          </div>
        </div>
      </div>
      <FContainer>
        <FInputText
          title="Correo electrónico"
          placeholder="Correo electrónico"
          toLowerCase={true}
          onChange={(value) => {
            setFieldValue("email", value);
          }}
          errorMessage={errors.email}
        />
        <br />
        <div className="border-0 w-full font-bold">
          <Switch
          onColor="#F10C8F"
            onChange={() => {
              if (!emails.length > 0 ? false : true) {
                setPrincipal(!principal);
              }
            }}
            checked={principal}
          />
          {" Marcar como dirección principal"}
        </div>
        <Fbutton
          value="Continuar"
          disabled={!(isValid && dirty)}
          onClick={handleSubmit}
        />
      </FContainer>
    </>
  );
};

export default CreateEmailScreen;
